import { connect } from 'react-redux';
import * as signatureActions from '../../redux/actions/signatureActions';

export default (WrappedComponent) => connect(null, signatureActions)(WrappedComponent);
